

const DIRECTIONS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

export const calculateDirection = (bearing) => {
    if (bearing == null || bearing === '') return '';
    const b = ((Number(bearing) % 360) + 360) % 360;
    return DIRECTIONS[Math.round(b / 22.5) % 16];
}

export const shadingString = (data) => {
    let output = ''
    switch (data) {
        case '0.96':
            output = 'none (0%)';
            break;
        case '0.875':
            output = 'low (1-25%)';
            break;
        case '0.625':
            output = 'medium (25-50%)';
            break;
        case '0.375':
            output = 'high (50-75%)';
            break;
        case '0.125':
            output = 'very high (75-100%)';
            break;
        default:
            break;
    }
    return output;
};

export const energyString = (data) => {
    let output = ''
    switch (data) {
        default:
            output = 'home all day';
            break;
        case 'inHalfDay':
            output = 'in half the day';
            break;
        case 'outAllDay':
            output = 'out all day';
            break;
    }
    return output;
};

